import { DefectPassedRetest, DefectSeverity, DefectStatus } from '../../models/defect.model';
import { StatusKind } from '../../components/status-pill/status-pill.component';

export const DEFECT_STATUSES: readonly DefectStatus[] = ['OPEN', 'IN_PROGRESS', 'FIXED', 'VERIFIED', 'REJECTED'];

export const DEFECT_SEVERITIES: readonly DefectSeverity[] = ['CRITICAL', 'HIGH', 'MEDIUM', 'LOW'];

// Spiegel von DefectTransitions im Backend (ARCHITECTURE.md §3.7); der Server prueft beides erneut.
const NEXT: Record<DefectStatus, readonly DefectStatus[]> = {
  OPEN: ['IN_PROGRESS', 'REJECTED'],
  IN_PROGRESS: ['OPEN', 'FIXED', 'REJECTED'],
  FIXED: ['IN_PROGRESS', 'VERIFIED'],
  REJECTED: ['OPEN'],
  VERIFIED: [],
};

export interface DefectStatusOption {
  status: DefectStatus;
  allowed: boolean;
  reason: 'notAllowed' | 'needsRetest' | null;
}

export function statusOptions(current: DefectStatus, passedRetest: DefectPassedRetest | null): DefectStatusOption[] {
  return DEFECT_STATUSES.map((status) => {
    if (status === current) return { status, allowed: true, reason: null };
    if (!NEXT[current].includes(status)) return { status, allowed: false, reason: 'notAllowed' };
    if (status === 'VERIFIED' && !passedRetest) return { status, allowed: false, reason: 'needsRetest' };
    return { status, allowed: true, reason: null };
  });
}

const KIND: Record<DefectStatus, StatusKind> = {
  OPEN: 'fehler',
  IN_PROGRESS: 'laufend',
  FIXED: 'pending',
  VERIFIED: 'aktiv',
  REJECTED: 'inaktiv',
};

export function defectStatusKind(status: DefectStatus): StatusKind {
  return KIND[status];
}

/** Farbton der Pillen (FePill, page-fehler.jsx:26-38); die Töne stehen als Repo-Tokens in _defects-shared.scss. */
export type DefectTone = 'red' | 'orange' | 'warn' | 'low' | 'neutral' | 'accent' | 'green' | 'verified' | 'muted';

const SEVERITY_TONE: Record<DefectSeverity, DefectTone> = {
  CRITICAL: 'red',
  HIGH: 'orange',
  MEDIUM: 'warn',
  LOW: 'low',
};

const STATUS_TONE: Record<DefectStatus, DefectTone> = {
  OPEN: 'neutral',
  IN_PROGRESS: 'accent',
  FIXED: 'green',
  VERIFIED: 'verified',
  REJECTED: 'muted',
};

export function defectSeverityTone(severity: DefectSeverity): DefectTone {
  return SEVERITY_TONE[severity];
}

export function defectStatusTone(status: DefectStatus): DefectTone {
  return STATUS_TONE[status];
}
